<my-bill-odb-page-base-structure
  [billingDocument]="billDocument"
  [hasTopContent]="true"
  [hasCommonHeader]="true"
>
  <div
    class="rs-panel-big rs-bg-c2 rs-box-shadow"
    data-cy="myBillDeferralAcceptNewDatePage"
    topContent
  >
    <h2 class="rs-tit3">{{ 'bills.deferral.acceptDate.title' | translate }}</h2>
    <div class="row">
      <div class="small-12 medium-6 columns">
        <p data-cy="myBillDeferralSelectNewDateSubtitle">
          {{ 'bills.deferral.acceptDate.description' | translate }}
        </p>
        <p data-cy="myBillDeferralTotalToPay">
          <span class="rs-font-pxB"
            >{{ 'bills.deferral.acceptDate.totalToPay' | translate }}
          </span>
          <px-currency-amount
            [amountClass]="'rs-price-sm'"
            [amount]="billDocument?.amount"
          ></px-currency-amount>
        </p>
        <hr />
        <div class="row">
          <div class="small-12 medium-6 columns">
            <p class="rs-font-pxB" data-cy="myBillDeferralInitialDate">
              {{ 'bills.deferral.acceptDate.initialPaymentDate' | translate
              }}<br />{{ billDocument?.dueDate }}
            </p>
          </div>
          <div class="small-12 medium-6 columns">
            <p class="rs-font-pxB" data-cy="myBillDeferralDeferredDate">
              {{ 'bills.deferral.acceptDate.newPaymentDate' | translate
              }}<br /><span class="rs-txt-success"
                >{{ selectedNewPaymentDate }}
              </span>
            </p>
          </div>
        </div>

        <hr class="show-for-small-only" />
      </div>
      <div class="small-12 medium-6 columns">
        <my-bill-deferral-rules-list></my-bill-deferral-rules-list>

        <div class="rs-form-item">
          <div
            class="rs-checkbox"
            data-cy="myBillDeferralAcceptNewDateCheckboxTNC"
          >
            <input
              type="checkbox"
              name="check2"
              id="ac-check2"
              [(ngModel)]="isTermsAccepted"
            /><label for="ac-check2">{{
              'bills.deferral.acceptDate.termsInfo' | translate
            }}</label>
          </div>
        </div>
        <div class="rs-flex-row rs-flex-dir-col-small-only">
          <div class="rs-flex-column rs-order-m2">
            <a
              *ngIf="(deferralState$ | async).isSaving"
              href="javascript:void(0)"
              class="rs-btn rs-btn-waiting rs-btn-nl-so"
              aria-live="polite"
              data-cy="myBillDeferralAcceptNewDateConfirmButton"
            >
              {{ 'bills.deferral.acceptDate.loading' | translate }}
              <div class="rs-btn-waiting-dots"></div>
            </a>
            <a
              *ngIf="!(deferralState$ | async).isSaving"
              (click)="saveDeferralDate()"
              class="rs-btn rs-btn-nl-so"
              [attr.aria-disabled]="!isTermsAccepted"
              data-tms-event="button-click"
              data-tms-button-zone="mybill.deferral_accept_new_date"
              data-tms-button-name="confirm payment deferral"
              [attr.data-tms-message-info]="paNumber"
              [attr.data-tms-context]="billDocument?.reference"
              data-cy="myBillDeferralAcceptNewDateConfirmButton"
              >{{ 'bills.deferral.acceptDate.confirmBtn' | translate }}
            </a>
          </div>
          <my-bill-back-button
            [customLabel]="'bills.deferral.acceptDate.previousBtn'"
            [backButtonType]="'firstButtonWithLeftArrow'"
          ></my-bill-back-button>
        </div>
      </div>
    </div>
  </div>
</my-bill-odb-page-base-structure>
<lib-overlayer-message
  *ngIf="(deferralState$ | async).hasError"
  [messageType]="messageBoxTypeError"
  [closeMessageBoxTranslation]="
    'bills.deferral.acceptDate.error.close' | translate
  "
  [showModal]="true"
  (onClose)="closeModal()"
  (footerMainButtonClick)="closeModal()"
  [footerMainButtonLabel]="'bills.deferral.acceptDate.error.close' | translate"
  [showCross]="true"
  id="msgOver-info-error-deferral-call"
  data-tms-event="popup-impression"
  data-tms-popup-zone="mybill.deferral_accept_new_date"
  data-tms-popup-name="warning message about deferral payment error"
  [attr.data-tms-message-info]="paNumber"
  [attr.data-tms-context]="billDocument?.reference"
>
  >
  <p Title class="rs-msgbox-title">
    {{ 'bills.deferral.acceptDate.error.title' | translate }}
  </p>
  <p Content>{{ 'bills.deferral.acceptDate.error.content' | translate }}</p>
</lib-overlayer-message>
